import type { Dictionary } from '../bs'
import { common } from './common'
import { auth } from './auth'
import { shell } from './shell'
import { home } from './home'
import { submissions } from './submissions'
import { tasks } from './tasks'
import { fiveS } from './fiveS'
import { profile } from './profile'
import { notifications } from './notifications'
import { analytics } from './analytics'
import { admin } from './admin'
import { guide } from './guide'
import { owner } from './owner'
import { people } from './people'

/**
 * Croatian: Bosnian, with the words that genuinely differ.
 *
 * `Partial`, because that is the honest type — this is a diff, not a
 * translation. Croatian is ijekavica like Bosnian, so nothing moves for the jat
 * reflex; what changes is vocabulary, in a few recognisable families:
 *
 *   - *sustav* for system, *tvrtka* for company, *računalo* for computer;
 *   - *datoteka* for file, *poveznica* for link, *tipka* for key;
 *   - *sigurnost* rather than *bezbjednost*;
 *   - borrowed verbs in **-irati** rather than -ovati.
 *
 * An entry identical to its Bosnian base is a bug rather than a harmless
 * duplicate, and `i18n.test.ts` fails on one: a line that changes nothing is a
 * decision that was reverted in `bs` without anybody revisiting this file.
 */
export const hr: Partial<Dictionary> = {
  ...common,
  ...auth,
  ...shell,
  ...home,
  ...submissions,
  ...tasks,
  ...fiveS,
  ...profile,
  ...notifications,
  ...analytics,
  ...admin,
  ...guide,
  ...owner,
  ...people,
}
